import { TenantDetalhe } from "features/tenants/typings/tenant";
import { useMutation } from "react-query";
import http from "infra/http";

function useSaveCliente(id?: string) {
  return useMutation(
    "/v1/clientes-tenant",
    (data: TenantDetalhe) => {
      data.pessoa.contatos = Array.isArray(data.pessoa.contatos)
        ? data.pessoa.contatos
        : [];

      return id
        ? http.put(`/v1/clientes-tenant/${id}`, data)
        : http.post("/v1/clientes-tenant", data);
    },
    { retry: false }
  );
}

export default useSaveCliente;
